import { __extends } from "tslib";
import { TicketContextView } from './ticket-context-view/ticket-context-view.comp';
import { ArticleContextView } from './article-context-view/article-context-view.comp';
import { ToolbarContextSections } from '../user-toolbar.comp';
import * as React from 'react';
import { Checkbox, InfoTooltip } from '@wix/answers-ui-libby';
import { namespacedClassnames } from '../../utils';
var ToolbarContextView = /** @class */ (function (_super) {
    __extends(ToolbarContextView, _super);
    function ToolbarContextView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isStatsOpen: false,
            currentContext: _this.props.visibleContext
        };
        _this.compTranslate = function (key, params) {
            if (params === void 0) { params = {}; }
            var prefix = _this.props.translationPrefix || 'public.user-toolbar';
            return _this.props.translate(prefix + "." + key, params);
        };
        _this.commonTranslate = function (key, params) {
            if (params === void 0) { params = {}; }
            var prefix = _this.props.translationPrefix || 'common';
            return _this.props.translate(prefix + "." + key, params);
        };
        _this.onCategoryFollowChange = function (toggleFollow) {
            var contextData = _this.props.contextData;
            if (contextData && contextData.categoryContext) {
                contextData.categoryContext.onFollowToggle(toggleFollow);
            }
        };
        _this.renderCategoryContextView = function () {
            var contextData = _this.props.contextData;
            var categoryContext = contextData ? contextData.categoryContext : null;
            return !!categoryContext ? (React.createElement("div", { className: 'category-context-container' },
                React.createElement("label", { className: 'follow-category' },
                    React.createElement(Checkbox, { value: categoryContext.isFollowing, onChange: _this.onCategoryFollowChange }, _this.compTranslate('category.follow'))),
                React.createElement(InfoTooltip, { text: _this.compTranslate('category.tooltip'), relativeToBody: true }))) : null;
        };
        return _this;
    }
    ToolbarContextView.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ currentContext: nextProps.visibleContext });
    };
    ToolbarContextView.prototype.render = function () {
        var currentContext = this.state.currentContext;
        var contextData = this.props.contextData;
        var classNames = namespacedClassnames('toolbar-context-container');
        var showArticleContext = currentContext === ToolbarContextSections.ARTICLE;
        var showTicketContext = currentContext === ToolbarContextSections.TICKET;
        var showCategoryContext = currentContext === ToolbarContextSections.CATEGORY;
        var articleContextComp = showArticleContext ?
            React.createElement(ArticleContextView, { translate: this.compTranslate, commonTrans: this.commonTranslate, contextData: contextData })
            : null;
        var ticketContextComp = showTicketContext ?
            React.createElement(TicketContextView, { translate: this.compTranslate, contextData: contextData })
            : null;
        var categoryContextComp = showCategoryContext ?
            this.renderCategoryContextView()
            : null;
        return (React.createElement("div", { className: classNames },
            articleContextComp,
            ticketContextComp,
            categoryContextComp));
    };
    return ToolbarContextView;
}(React.Component));
export { ToolbarContextView };
//# sourceMappingURL=toolbar-context.comp.js.map